import { useState } from "react";
import { api } from "../api.js";
import { Field } from "./shared.jsx";
import { t, LangSwitch, MadeByBadge } from "../i18n.jsx";

export default function LoginScreen({ onLoggedIn, lang, onLangChange }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await api.login(email, password);
      onLoggedIn(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card card">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.4em" }}>
          <LangSwitch lang={lang} onChange={onLangChange} />
        </div>
        <div className="login-logo">
          <div className="mark">SOP</div>
          <h1 style={{ marginBottom: 2 }}>SOP Management</h1>
          <div style={{ color: "var(--ink-dim)", fontSize: "0.85rem" }}>
            {t(lang, "Standarde, Proceduri & Instrucțiuni de Securitate")}
          </div>
        </div>
        {error && <div className="error-box">{error}</div>}
        <form onSubmit={submit}>
          <Field label={t(lang, "Email")}>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </Field>
          <Field label={t(lang, "Parolă")}>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </Field>
          <button className="btn btn-accent" style={{ width: "100%" }} disabled={loading}>
            {loading ? t(lang, "Se conectează…") : t(lang, "Conectare")}
          </button>
        </form>
        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.4em" }}>
          <MadeByBadge lang={lang} />
        </div>
      </div>
    </div>
  );
}
